export const AUTH_SESSION_KEY = 'DD_JWT';

export function initAuthFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const jwt = params.get('jwt');
    if (jwt) {
      sessionStorage.setItem(AUTH_SESSION_KEY, jwt);
      // Remove jwt param from URL to avoid leaking in referrers/history
      const url = new URL(window.location.href);
      url.searchParams.delete('jwt');
      window.history.replaceState({}, document.title, url.toString());
    }
  } catch (err) {
    // noop
  }
}

export function getAuthToken(): string | null {
  return sessionStorage.getItem(AUTH_SESSION_KEY);
}

export function setAuthToken(token: string) {
  sessionStorage.setItem(AUTH_SESSION_KEY, token);
}

export function clearAuthToken() {
  sessionStorage.removeItem(AUTH_SESSION_KEY);
}
